"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Errors = require("../errors/Errors");

var _cancel = _interopRequireDefault(require("../change/cancel"));

var _ChangeRequest = _interopRequireDefault(require("../change/ChangeRequest"));

var _Action = _interopRequireDefault(require("../change/Action"));

var _isIndexedValue = _interopRequireDefault(require("../parcelData/isIndexedValue"));

var _isParentValue = _interopRequireDefault(require("../parcelData/isParentValue"));

var _deleted = _interopRequireDefault(require("../parcelData/deleted"));

var _prepUpdater = _interopRequireDefault(require("../parcelData/prepUpdater"));

var _setMetaDefault = _interopRequireDefault(require("../parcelData/setMetaDefault"));

var _prepareChildKeys = _interopRequireDefault(require("../parcelData/prepareChildKeys"));

var _keyOrIndexToKey = _interopRequireDefault(require("../parcelData/keyOrIndexToKey"));

var _get = _interopRequireDefault(require("../parcelData/get"));

var _has = _interopRequireDefault(require("../parcelData/has"));

var _filter = _interopRequireDefault(require("unmutable/filter"));

var _has2 = _interopRequireDefault(require("unmutable/has"));

var _pipeWith = _interopRequireDefault(require("unmutable/pipeWith"));

var _first = _interopRequireDefault(require("unmutable/first"));

var _last = _interopRequireDefault(require("unmutable/last"));

var _clone = _interopRequireDefault(require("unmutable/clone"));

var _map = _interopRequireDefault(require("unmutable/map"));

var _size = _interopRequireDefault(require("unmutable/size"));

var _toArray = _interopRequireDefault(require("unmutable/toArray"));

var _HashString = _interopRequireDefault(require("../util/HashString"));

var doNothing = function doNothing(ii) {
  return ii;
};

var escapeKey = function escapeKey(key) {
  return key.replace(/([^\w])/g, "%$1");
};

var DEFAULT_CONFIG_INTERNAL = function DEFAULT_CONFIG_INTERNAL() {
  return {
    child: undefined,
    dispatchId: '',
    frameMeta: {},
    meta: {},
    rawId: ["^"],
    rawPath: ["^"],
    parent: {
      isIndexed: false,
      isChildFirst: false,
      isChildLast: false
    },
    registry: {},
    updateChangeRequestOnDispatch: doNothing
  };
};

var Parcel =
/*#__PURE__*/
function () {
  //
  // private member variables
  //
  // from constructor
  //
  // public methods
  //
  // Spread methods
  // Branch methods
  // Parent methods
  // Child methods
  // Side-effect methods
  // Change methods
  // Advanced change methods
  // Indexed methods
  // Modify methods
  // Type methods
  // Composition methods
  function Parcel() {
    var _this = this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _configInternal = arguments.length > 1 ? arguments[1] : undefined;

    (0, _classCallCheck2["default"])(this, Parcel);
    (0, _defineProperty2["default"])(this, "_childParcelCache", {});
    (0, _defineProperty2["default"])(this, "_dispatchId", void 0);
    (0, _defineProperty2["default"])(this, "_rawId", void 0);
    (0, _defineProperty2["default"])(this, "_rawPath", void 0);
    (0, _defineProperty2["default"])(this, "_isChild", void 0);
    (0, _defineProperty2["default"])(this, "_isElement", void 0);
    (0, _defineProperty2["default"])(this, "_isIndexed", void 0);
    (0, _defineProperty2["default"])(this, "_isParent", void 0);
    (0, _defineProperty2["default"])(this, "_frameMeta", void 0);
    (0, _defineProperty2["default"])(this, "_methods", void 0);
    (0, _defineProperty2["default"])(this, "_onHandleChange", void 0);
    (0, _defineProperty2["default"])(this, "_parcelData", void 0);
    (0, _defineProperty2["default"])(this, "_parent", void 0);
    (0, _defineProperty2["default"])(this, "_registry", void 0);
    (0, _defineProperty2["default"])(this, "_updateChangeRequestOnDispatch", void 0);
    (0, _defineProperty2["default"])(this, "spread", void 0);
    (0, _defineProperty2["default"])(this, "spreadDOM", void 0);
    (0, _defineProperty2["default"])(this, "spreadDOMCheckbox", void 0);
    (0, _defineProperty2["default"])(this, "get", void 0);
    (0, _defineProperty2["default"])(this, "getIn", void 0);
    (0, _defineProperty2["default"])(this, "children", void 0);
    (0, _defineProperty2["default"])(this, "toArray", void 0);
    (0, _defineProperty2["default"])(this, "metaAsParcel", void 0);
    (0, _defineProperty2["default"])(this, "has", void 0);
    (0, _defineProperty2["default"])(this, "size", void 0);
    (0, _defineProperty2["default"])(this, "isFirst", void 0);
    (0, _defineProperty2["default"])(this, "isLast", void 0);
    (0, _defineProperty2["default"])(this, "spy", void 0);
    (0, _defineProperty2["default"])(this, "spyChange", void 0);
    (0, _defineProperty2["default"])(this, "onChange", void 0);
    (0, _defineProperty2["default"])(this, "onChangeDOM", void 0);
    (0, _defineProperty2["default"])(this, "onChangeDOMCheckbox", void 0);
    (0, _defineProperty2["default"])(this, "set", void 0);
    (0, _defineProperty2["default"])(this, "update", void 0);
    (0, _defineProperty2["default"])(this, "delete", void 0);
    (0, _defineProperty2["default"])(this, "map", void 0);
    (0, _defineProperty2["default"])(this, "setMeta", void 0);
    (0, _defineProperty2["default"])(this, "dispatch", void 0);
    (0, _defineProperty2["default"])(this, "insertAfter", void 0);
    (0, _defineProperty2["default"])(this, "insertBefore", void 0);
    (0, _defineProperty2["default"])(this, "push", void 0);
    (0, _defineProperty2["default"])(this, "pop", void 0);
    (0, _defineProperty2["default"])(this, "shift", void 0);
    (0, _defineProperty2["default"])(this, "swap", void 0);
    (0, _defineProperty2["default"])(this, "swapNext", void 0);
    (0, _defineProperty2["default"])(this, "swapPrev", void 0);
    (0, _defineProperty2["default"])(this, "unshift", void 0);
    (0, _defineProperty2["default"])(this, "modifyDown", void 0);
    (0, _defineProperty2["default"])(this, "modifyUp", void 0);
    (0, _defineProperty2["default"])(this, "initialMeta", void 0);
    (0, _defineProperty2["default"])(this, "isChild", function () {
      return _this._isChild;
    });
    (0, _defineProperty2["default"])(this, "isElement", function () {
      return _this._isElement;
    });
    (0, _defineProperty2["default"])(this, "isIndexed", function () {
      return _this._isIndexed;
    });
    (0, _defineProperty2["default"])(this, "isParent", function () {
      return _this._isParent;
    });
    (0, _defineProperty2["default"])(this, "isTopLevel", function () {
      return !_this._isChild;
    });
    (0, _defineProperty2["default"])(this, "pipe", function () {
      for (var _len = arguments.length, updaters = new Array(_len), _key = 0; _key < _len; _key++) {
        updaters[_key] = arguments[_key];
      }

      return _pipeWith["default"].apply(void 0, [_this].concat(updaters));
    });
    (0, _defineProperty2["default"])(this, "_create", function (createParcelConfig) {
      var _createParcelConfig$d = createParcelConfig.dispatchId,
          dispatchId = _createParcelConfig$d === void 0 ? _this.id : _createParcelConfig$d,
          handleChange = createParcelConfig.handleChange,
          _createParcelConfig$r = createParcelConfig.rawId,
          rawId = _createParcelConfig$r === void 0 ? _this._rawId : _createParcelConfig$r,
          _createParcelConfig$r2 = createParcelConfig.rawPath,
          rawPath = _createParcelConfig$r2 === void 0 ? _this._rawPath : _createParcelConfig$r2,
          _createParcelConfig$f = createParcelConfig.frameMeta,
          frameMeta = _createParcelConfig$f === void 0 ? _this._frameMeta : _createParcelConfig$f,
          _createParcelConfig$p = createParcelConfig.parcelData,
          parcelData = _createParcelConfig$p === void 0 ? _this._parcelData : _createParcelConfig$p,
          _createParcelConfig$p2 = createParcelConfig.parent,
          parent = _createParcelConfig$p2 === void 0 ? _this._parent : _createParcelConfig$p2,
          _createParcelConfig$r3 = createParcelConfig.registry,
          registry = _createParcelConfig$r3 === void 0 ? _this._registry : _createParcelConfig$r3,
          _createParcelConfig$u = createParcelConfig.updateChangeRequestOnDispatch,
          updateChangeRequestOnDispatch = _createParcelConfig$u === void 0 ? doNothing : _createParcelConfig$u;
      var child = parcelData.child,
          value = parcelData.value,
          _parcelData$meta = parcelData.meta,
          meta = _parcelData$meta === void 0 ? {} : _parcelData$meta;
      return new Parcel({
        value: value,
        handleChange: handleChange
      }, {
        child: child,
        dispatchId: dispatchId,
        frameMeta: frameMeta,
        meta: meta,
        rawId: rawId,
        rawPath: rawPath,
        parent: parent,
        registry: registry,
        updateChangeRequestOnDispatch: updateChangeRequestOnDispatch
      });
    });
    (0, _defineProperty2["default"])(this, "_setData", function (parcelData) {
      _this._dispatch(new _Action["default"]({
        type: 'setData',
        payload: parcelData
      }));
    });
    (0, _defineProperty2["default"])(this, "_dispatch", function (dispatchable) {
      // Types(`dispatch()`, `dispatchable`, `dispatchable`)(dispatchable);
      var _updateChangeRequestOnDispatch = _this._updateChangeRequestOnDispatch,
          _onHandleChange = _this._onHandleChange;
      var changeRequest = dispatchable instanceof _ChangeRequest["default"] ? dispatchable : new _ChangeRequest["default"](dispatchable);

      if (!changeRequest._originId) {
        changeRequest._originId = _this.id;
        changeRequest._originPath = _this.path;
      } // clear changeRequest's cache


      changeRequest = changeRequest._create({});

      if (_onHandleChange) {
        var changeRequestWithBase = changeRequest._create({
          prevData: _this.data
        });

        var parcelData = changeRequestWithBase.nextData;

        if (!parcelData) {
          return;
        }

        var parcelWithChangedData = _this._create({
          handleChange: _onHandleChange,
          parcelData: parcelData,
          frameMeta: changeRequest._nextFrameMeta
        });

        _onHandleChange(parcelWithChangedData, changeRequestWithBase);

        return;
      }

      _this._dispatchToParent(_updateChangeRequestOnDispatch(changeRequest));
    });
    (0, _defineProperty2["default"])(this, "_dispatchToParent", function (changeRequest) {
      var parcel = _this._registry[_this._dispatchId];

      if (parcel) {
        parcel._dispatch(changeRequest);
      }
    });
    (0, _defineProperty2["default"])(this, "_changeAndReturn", function (changeCatcher) {
      var result;
      var _onHandleChange = _this._onHandleChange; // swap out the parcels real _onHandleChange with a spy

      _this._onHandleChange = function (parcel, changeRequest) {
        parcel._onHandleChange = _onHandleChange;
        parcel._frameMeta = _this._frameMeta;
        result = [parcel, changeRequest];
      };

      changeCatcher(_this);
      _this._onHandleChange = _onHandleChange;

      if (!result) {
        return [_this, undefined];
      }

      return result;
    });
    (0, _defineProperty2["default"])(this, "_boundarySplit", function (_ref) {
      var handleChange = _ref.handleChange;
      return _this._create({
        rawId: _this._idPushModifier('bs'),
        handleChange: handleChange // temporarily disabling boundary splitting
        // until a more robust solution can be found
        // dispatchId: '%',
        // registry: {
        //     '%': this
        // }

      });
    });
    (0, _defineProperty2["default"])(this, "_get", function (key, notFoundValue) {
      //Types(`get()`, `key`, `keyIndex`)(key);
      var stringKey = (0, _keyOrIndexToKey["default"])(key)(_this._parcelData);
      var cachedChildParcel = _this._childParcelCache[stringKey];

      if (cachedChildParcel) {
        return cachedChildParcel;
      }

      _this._prepareChildKeys();

      var childParcelData = (0, _get["default"])(key, notFoundValue)(_this._parcelData); // this shouldn't happen in reality, but I cant prove that to flow right now
      // and it rightly should be an error

      if (childParcelData.key === undefined) {
        throw new Error();
      }

      var childKey = childParcelData.key;

      var childOnDispatch = function childOnDispatch(changeRequest) {
        return changeRequest._addStep({
          type: 'get',
          key: childKey
        });
      };

      var child = _this._parcelData.child;
      var childIsNotEmpty = (0, _size["default"])()(child) > 0;
      var isIndexed = _this._isIndexed;
      var isChildFirst = childIsNotEmpty && (0, _first["default"])()(child).key === childKey;
      var isChildLast = childIsNotEmpty && (0, _last["default"])()(child).key === childKey;
      var rawId = [].concat((0, _toConsumableArray2["default"])(_this._rawId), [isIndexed ? childKey : escapeKey(childKey)]);
      var rawPath = [].concat((0, _toConsumableArray2["default"])(_this._rawPath), [childKey]);

      var childParcel = _this._create({
        parcelData: childParcelData,
        updateChangeRequestOnDispatch: childOnDispatch,
        rawId: rawId,
        rawPath: rawPath,
        parent: {
          isIndexed: isIndexed,
          isChildFirst: isChildFirst,
          isChildLast: isChildLast
        }
      });

      _this._childParcelCache[stringKey] = childParcel;
      return childParcel;
    });
    (0, _defineProperty2["default"])(this, "_getValue", function (notFoundValue) {
      var value = _this.value;
      return value === _deleted["default"] || value === undefined ? notFoundValue : value;
    });
    (0, _defineProperty2["default"])(this, "_getKeyFromRawPath", function (rawPath) {
      return (0, _last["default"])()(rawPath);
    });
    (0, _defineProperty2["default"])(this, "_getIdFromRawId", function (rawId) {
      return rawId.join('.');
    });
    (0, _defineProperty2["default"])(this, "_idPushModifier", function (name) {
      return [].concat((0, _toConsumableArray2["default"])(_this._rawId), ["~".concat(name)]);
    });
    (0, _defineProperty2["default"])(this, "_idPushModifierUpdater", function (prefix, updater) {
      var hash = function hash(fn) {
        return "".concat((0, _HashString["default"])(fn.toString()));
      };

      var id = updater._asRaw ? "s".concat(hash(updater._updater || updater)) : hash(updater);
      return _this._idPushModifier("".concat(prefix, "-").concat(id));
    });
    (0, _defineProperty2["default"])(this, "_prepareChildKeys", function () {
      if (!_this._parcelData.child) {
        _this._parcelData = (0, _prepareChildKeys["default"])()(_this._parcelData);
      }
    }); //Types(`Parcel()`, `config`, `object`)(config);

    var _handleChange = config.handleChange,
        _value = config.value; //handleChange && Types(`Parcel()`, `config.handleChange`, `function`)(handleChange);

    var _ref2 = _configInternal || DEFAULT_CONFIG_INTERNAL(),
        _child = _ref2.child,
        _dispatchId = _ref2.dispatchId,
        _frameMeta = _ref2.frameMeta,
        _meta = _ref2.meta,
        _rawId = _ref2.rawId,
        _rawPath = _ref2.rawPath,
        _parent = _ref2.parent,
        _registry = _ref2.registry,
        _updateChangeRequestOnDispatch2 = _ref2.updateChangeRequestOnDispatch;

    this._frameMeta = _frameMeta;
    this._onHandleChange = _handleChange;
    this._updateChangeRequestOnDispatch = _updateChangeRequestOnDispatch2;
    this._parcelData = {
      value: _value,
      child: _child,
      key: this._getKeyFromRawPath(_rawPath),
      meta: _meta
    };
    this._dispatchId = _dispatchId;
    this._rawId = _rawId;
    this._rawPath = _rawPath;
    this._isChild = _rawPath.length > 1;
    this._isElement = _parent.isIndexed;
    this._isIndexed = (0, _isIndexedValue["default"])(_value);
    this._isParent = (0, _isParentValue["default"])(_value);
    this._parent = _parent;
    this._registry = _registry;
    this._registry[this._getIdFromRawId(_rawId)] = this; //
    // method prep
    //

    var fireAction = function fireAction(type, payload, keyPath) {
      _this._dispatch(new _Action["default"]({
        type: type,
        keyPath: keyPath,
        payload: payload
      }));
    };

    var onlyType = function onlyType(type, name, fn) {
      // $FlowFixMe
      if (!_this["_is".concat(type)]) {
        return function () {
          throw (0, _Errors.ParcelTypeMethodMismatch)(name, type, _this.path);
        };
      }

      return fn;
    };

    var fireActionOnlyType = function fireActionOnlyType(type, name, payload, keyPath) {
      return onlyType(type, name, function () {
        return fireAction(name, payload, keyPath);
      })();
    };

    var Parent = 'Parent';
    var Child = 'Child';
    var Indexed = 'Indexed';
    var Element = 'Element'; //
    // public methods
    //
    // Spread Methods

    this.spread = function (notFoundValue) {
      return {
        value: _this._getValue(notFoundValue),
        onChange: _this.onChange
      };
    };

    this.spreadDOM = function (notFoundValue) {
      return {
        value: _this._getValue(notFoundValue),
        onChange: _this.onChangeDOM
      };
    };

    this.spreadDOMCheckbox = function (notFoundValue) {
      return {
        checked: !!_this._getValue(notFoundValue),
        onChange: _this.onChangeDOMCheckbox
      };
    }; // Branch methods


    this.get = onlyType(Parent, 'get', this._get); // Types(`getIn()`, `keyPath`, `keyIndexPath`)(keyPath);

    this.getIn = onlyType(Parent, 'getIn', function (keyPath, notFoundValue) {
      var parcel = _this;

      for (var i = 0; i < keyPath.length; i++) {
        parcel = parcel.get(keyPath[i], i < keyPath.length - 1 ? {} : notFoundValue);
      }

      return parcel;
    }); // Types(`children()`, `mapper`, `function`)(mapper);

    this.children = onlyType(Parent, 'children', function () {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : doNothing;
      return (0, _pipeWith["default"])(_this._parcelData.value, (0, _clone["default"])(), (0, _map["default"])(function (value, key) {
        return mapper(_this.get(key), key, _this);
      }));
    }); // Types(`toArray()`, `mapper`, `function`)(mapper);

    this.toArray = onlyType(Parent, 'toArray', function () {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : doNothing;
      return (0, _toArray["default"])()(_this.children(mapper));
    });

    this.metaAsParcel = function (key) {
      return new Parcel({
        value: _this.meta[key],
        handleChange: function handleChange(_ref3) {
          var value = _ref3.value;
          return _this.setMeta((0, _defineProperty2["default"])({}, key, value));
        }
      });
    }; // Parent methods
    //Types(`has()`, `key`, `keyIndex`)(key);


    this.has = onlyType(Parent, 'has', function (key) {
      _this._prepareChildKeys();

      return (0, _has["default"])(key)(_this._parcelData);
    });
    this.size = onlyType(Parent, 'size', function () {
      return (0, _size["default"])()(_this.value);
    }); // Child methods

    this.isFirst = function () {
      return _this._parent.isChildFirst;
    };

    this.isLast = function () {
      return _this._parent.isChildLast;
    }; // Side-effect methods
    // Types(`spy()`, `sideEffect`, `function`)(sideEffect);


    this.spy = function (sideEffect) {
      sideEffect(_this);
      return _this;
    }; // Types(`spyChange()`, `sideEffect`, `function`)(sideEffect);


    this.spyChange = function (sideEffect) {
      return _this._create({
        rawId: _this._idPushModifier('sc'),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          var basedChangeRequest = changeRequest._create({
            prevData: _this.data
          });

          sideEffect(basedChangeRequest);
          return changeRequest;
        }
      });
    }; // Change methods


    this.onChange = function (value) {
      return _this.set(value);
    }; // Types(`onChangeDOM()`, `event`, `event`)(event);


    this.onChangeDOM = function (event) {
      _this.set(event.currentTarget.value);
    }; // Types(`onChangeDOMCheckbox()`, `event`, `event`)(event);


    this.onChangeDOMCheckbox = function (event) {
      _this.set(event.currentTarget.checked);
    };

    this.set = function (value) {
      return fireAction('set', value);
    }; // Types(`update()`, `updater`, `function`)(updater);


    this.update = function (updater) {
      fireAction('setData', (0, _prepUpdater["default"])(updater)(_this._parcelData));
    };

    this["delete"] = function () {
      return fireActionOnlyType(Child, 'delete');
    }; // Types(`map()`, `updater`, `function`)(updater);


    this.map = function (updater) {
      fireActionOnlyType(Parent, 'map', (0, _prepUpdater["default"])(updater));
    }; // Advanced change methods
    // Types(`setMeta()`, `partialMeta`, `object`)(partialMeta);


    this.setMeta = function (meta) {
      return fireAction('setMeta', meta);
    };

    this.dispatch = this._dispatch; // Indexed methods
    // Types(`swap()`, `keyA`, `keyIndex`)(keyA);
    // Types(`swap()`, `keyB`, `keyIndex`)(keyB);

    this.insertAfter = function (value) {
      return fireActionOnlyType(Element, 'insertAfter', value);
    };

    this.insertBefore = function (value) {
      return fireActionOnlyType(Element, 'insertBefore', value);
    };

    this.push = function () {
      for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        values[_key2] = arguments[_key2];
      }

      return fireActionOnlyType(Indexed, 'push', values);
    };

    this.pop = function () {
      return fireActionOnlyType(Indexed, 'pop');
    };

    this.shift = function () {
      return fireActionOnlyType(Indexed, 'shift');
    };

    this.swap = function (keyA, keyB) {
      fireActionOnlyType(Indexed, 'swap', keyB, [keyA]);
    };

    this.swapNext = function () {
      return fireActionOnlyType(Element, 'swapNext');
    };

    this.swapPrev = function () {
      return fireActionOnlyType(Element, 'swapPrev');
    };

    this.unshift = function () {
      for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        values[_key3] = arguments[_key3];
      }

      return fireActionOnlyType(Indexed, 'unshift', values);
    }; // Modify methods
    // Types(`modifyDown()`, `updater`, `function`)(updater);


    this.modifyDown = function (updater) {
      var parcelDataUpdater = (0, _prepUpdater["default"])(updater);
      return _this._create({
        rawId: _this._idPushModifierUpdater('md', updater),
        parcelData: parcelDataUpdater(_this._parcelData),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          return changeRequest._addStep({
            type: 'md',
            updater: parcelDataUpdater
          });
        }
      });
    }; // Types(`modifyUp()`, `updater`, `function`)(updater);


    this.modifyUp = function (updater) {
      var parcelDataUpdater = function parcelDataUpdater(parcelData, changeRequest) {
        var nextData = (0, _prepUpdater["default"])(updater)(parcelData, changeRequest);

        if (nextData.value === _cancel["default"]) {
          throw new Error('CANCEL');
        }

        return nextData;
      };

      return _this._create({
        rawId: _this._idPushModifierUpdater('mu', updater),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          return changeRequest._addStep({
            type: 'mu',
            updater: parcelDataUpdater,
            changeRequest: changeRequest
          });
        }
      });
    }; // Types(`initialMeta()`, `initialMeta`, `object`)(initialMeta);


    this.initialMeta = function (initialMeta) {
      var meta = _this._parcelData.meta;
      var parcelDataUpdater = (0, _pipeWith["default"])(initialMeta, (0, _filter["default"])(function (value, key) {
        return !(0, _has2["default"])(key)(meta);
      }), _setMetaDefault["default"]);
      return _this._create({
        rawId: _this._idPushModifier('im'),
        parcelData: parcelDataUpdater(_this._parcelData),
        updateChangeRequestOnDispatch: function updateChangeRequestOnDispatch(changeRequest) {
          return changeRequest._addStep({
            type: 'mu',
            updater: parcelDataUpdater,
            changeRequest: changeRequest
          });
        }
      });
    };
  } //
  // private methods
  //


  (0, _createClass2["default"])(Parcel, [{
    key: "data",
    //
    // getters
    //
    // $FlowFixMe - this doesn't have side effects
    get: function get() {
      return this._parcelData;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "value",
    get: function get() {
      return this._parcelData.value;
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "meta",
    get: function get() {
      var meta = this._parcelData.meta;
      return (0, _objectSpread2["default"])({}, meta);
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "key",
    get: function get() {
      return this._getKeyFromRawPath(this._rawPath);
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "id",
    get: function get() {
      return this._getIdFromRawId(this._rawId);
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    } // $FlowFixMe - this doesn't have side effects

  }, {
    key: "path",
    get: function get() {
      return this._rawPath.slice(1);
    } // $FlowFixMe - this doesn't have side effects
    ,
    set: function set(value) {
      throw (0, _Errors.ReadOnlyError)();
    }
  }]);
  return Parcel;
}();

exports["default"] = Parcel;